import { useContext } from "react";
import RepositoryFolderContext from "../contexts/RepositoryFolderContext";

const useRepositoryFolder = () => {
  return useContext(RepositoryFolderContext);
};

export default useRepositoryFolder;
